import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { merge } from 'lodash';
// Services
import { JPathService } from '@cv-invision/cv.component-library.ux';
import { ViewsService } from '../../../services/views.service';
// Components
// import { ReviewFieldsComponent } from '../fields/display-field/review-fields.component';

@Component({
	selector: 'cv-review-static-tables',
	templateUrl: './review-static-tables.component.html',
	styleUrls: ['./review-static-tables.component.scss']
})
export class ReviewStaticTablesComponent implements OnInit {
	// @ViewChildren('fields') myFields: QueryList<ReviewFieldsComponent>;

	@Input() field: any;
	// @Input() selectedType = '';
	// @Input() selectedTargets: any;

	get document(): any {
		return this.viewsService.document;
	}
	get schema(): any {
		return this.viewsService.schema;
	}

	constructor(private viewsService: ViewsService, private jPathService: JPathService) {
		//
	}

	async ngOnInit(): Promise<void> {
		if ('comparables' in this.field.options) {
			const comparables = this.jPathService.getValue(document, `$.${this.field.options.comparables}`);
			const oldCols = merge([], this.field.options.rows[0].cols);
			const rows = [];

			await comparables.forEach((element, compIndex) => {
				const cols = [];
				oldCols.forEach((col, colIndex) => {
					const nCol: any = merge({}, oldCols[colIndex]);
					if (compIndex === 0 && colIndex === 0) {
						nCol.options.label = 'Subject';
					} else if (compIndex > 0 && colIndex === 0) {
						nCol.options.label += compIndex;
					}

					if ('path' in nCol.options) {
						const pathPattern = /(\[[a-zA-z=0-9'\\]+\])/g;
						const newPath = nCol.options.path.replace(pathPattern, match => {
							// eslint-disable-next-line
							const splitedValues = match.replace(/[\[\]\']+/g, '').split('=');
							const pathString = '[' + splitedValues[0] + '=' + compIndex + ']';

							return pathString;
						});
						nCol.options.path = newPath;
					}
					cols.push(nCol);
				});
				rows.push(Object.assign({ cols: cols }));
			});
			this.field.options.rows = rows;
		}
	}

}
